import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const contactChatAsk = (
  { candidateId, task, chatId, feed = [], regenerate },

  opts = {},
) =>
  swRequest(
    {
      path: "/api/contact_chat/ask",
      method: "POST",
      body: { candidateId, task, feed, chatId, regenerate },
    },
    opts,
  );

export const contactChatAskMeeting = (
  { meetingId, task, chatId, regenerate },
  opts = {},
) =>
  swRequest(
    {
      path: "/api/contact_chat/ask_meeting",
      method: "POST",
      body: { meetingId, task, chatId, regenerate },
    },
    opts,
  );

export const contactChatGet = ({ candidateId }, opts = {}) =>
  swRequest(
    {
      path: "/api/contact_chat/get",
      method: "GET",
      params: { candidateId },
    },
    opts,
  );

export const contactChatGetMeeting = ({ meetingId }, opts = {}) =>
  swRequest(
    {
      path: "/api/contact_chat/get_meeting",
      method: "GET",
      params: { meetingId },
    },
    opts,
  );

export const contactChatFeedback = ({ chatId, msgId, feedback }, opts = {}) =>
  swRequest(
    {
      path: "/api/contact_chat/feedback",
      method: "POST",
      body: { chatId, msgId, feedback },
    },
    opts,
  );
